import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import { ItemStatusOptions } from '../../../modules/constants';
import {
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';

const ItemsTransactionsReportFilter = ({
  publicZoneList,
  getPublicZoneList,
  officesShortList,
  getOfficesShortList,
  getItemsTransactionsList,
  selectedOrganization,
  getItemsList,
  itemsList,
  getOrganizationMembersList,
  orgMembersList,
  setSelectedParams,
  selectedParams,
}) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
  });
  const [dateUpdated, setDateUpdated] = useState(false);
  const [selectedPublicZone, setSelectedPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [item, setItem] = useState({
    label: t('all_items'),
    value: null,
  });
  const [publicZoneOptions, setPublicZoneOptions] = useState([
    {
      label: t('all_public_zones'),
      value: null,
    },
  ]);
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);
  const [itemOptions, setItemOptions] = useState([
    {
      label: t('all_items'),
      value: null,
    },
  ]);
  const [memberOptions, setMemberOptions] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState(null);

  useEffect(() => {
    getPublicZoneList && getPublicZoneList();
    getItemsList && getItemsList();
    console.log('in');

    getOrganizationMembersList();
  }, [selectedOrganization]);

  useEffect(() => {
    if (officesShortList && officesShortList.length === 1) {
      getOrganizationMembersList({ office_id: officesShortList[0].id });
    }
  }, [officesShortList]);

  useEffect(() => {
    if (selectedOffice?.value) {
      getOrganizationMembersList({ office_id: selectedOffice.value });
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (selectedPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    } else getOfficesShortList();
  }, [selectedPublicZone]);

  useEffect(() => {
    if (officesShortList && officesShortList.length >= 1) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach(office => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [
        {
          label: t('all_public_zones'),
          value: null,
        },
      ];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);

  useEffect(() => {
    if (itemsList && itemsList.length > 0) {
      let newArr = [
        {
          label: t('all_items'),
          value: null,
        },
      ];
      itemsList.forEach(item => {
        newArr.push({
          label: item.name,
          value: item.id,
        });
      });
      setItemOptions(newArr);
    }
  }, [itemsList]);

  useEffect(() => {
    setMemberOptions(orgMembersList);
  }, [orgMembersList]);

  useEffect(() => {
    selectedOrganization?.id && callGetItemsTransactionsList();
  }, [
    dateUpdated,
    selectedPublicZone,
    selectedOffice,
    item,
    selectedOrganization,
    selectedAssignee,
  ]);

  const callGetItemsTransactionsList = () => {
    const payload = {};
    selectedDate.startDate &&
      (payload.start = selectedDate.startDate.format('YYYY-MM-DD'));
    selectedDate.endDate &&
      (payload.end = selectedDate.endDate.format('YYYY-MM-DD'));
    selectedPublicZone?.value &&
      (payload.public_zone_id = selectedPublicZone.value);
    selectedOffice?.value && (payload.office_id = selectedOffice.value);
    item?.value && (payload.item_id = item.value);
    selectedAssignee?.id && (payload.assignees = selectedAssignee.id);

    setSelectedParams(payload);
    getItemsTransactionsList(payload);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handlePublicZoneChange = e => {
    setSelectedPublicZone(e);
  };

  const handleOfficeChange = e => {
    setSelectedOffice(e);
  };

  const handleItemChange = e => {
    setItem(e);
  };

  const handleAssigneeSelect = person => {
    setSelectedAssignee(person);
  };

  const handleClearAssignee = () => {
    setSelectedAssignee(null);
  };

  return (
    <FilterContainer marginTop="30px">
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('public_zone')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedPublicZone}
          options={publicZoneOptions}
          placeholder={t('select_public_zone')}
          onChange={handlePublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('office')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedOffice}
          options={officeOptions}
          placeholder={t('select_office')}
          onChange={handleOfficeChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>{' '}
      <InputWithLabelSection>
        <FilterLabel>{t('assignee')}</FilterLabel>
        <div style={{ width: `40px` }}>
          <AddSingleMemberDropdown
            assigneeManage={selectedAssignee}
            updateState={handleAssigneeSelect}
            membersList={memberOptions}
            clearAssignee={handleClearAssignee}
          />
        </div>
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('item')}</FilterLabel>
        <Select
          isSearchable={false}
          value={item}
          options={itemOptions}
          placeholder={t('select_item')}
          onChange={handleItemChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="max-content">
        <FilterLabel>{t('date_range')}</FilterLabel>
        <ReactDateRangePicker
          startDate={selectedDate.startDate}
          startDateId="items-transactions-start-date"
          endDate={selectedDate.endDate}
          endDateId="items-transactions-end-date"
          onDatesChange={handleDateChange}
          dateDisplayFormat="DD/MM/YYYY"
          onDateSelect={() => setDateUpdated(!dateUpdated)}
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default ItemsTransactionsReportFilter;
